const APIS = {
    DEFAULT_BRANCH: "/logisticservice/api/branch/default-branch/",
    STAFF: "/logisticservice/api/staff/",
    USER: "/logisticservice/api/user/",
    USER_PROFILE: "/logisticservice/api/user-profile/",
    PRODUCT_TYPE:"/logisticservice/api/product-type/"
  };
  
  export default APIS;